import { ModalBackdropStyled, SideSheetHeader, SideSheetClose, Box, Button, ButtonAppearance } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const DrawerBackdropStyled = styled(ModalBackdropStyled)`
  position: absolute;
  left: 0;
  z-index: 2;
`;
export const DrawerOuterStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.grey['200']};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  display: flex;
  flex-direction: column;
  height: 100%;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 525px;
`;
export const DrawerHeaderStyled = styled(SideSheetHeader)`
  ${({ theme }) =>
    css`
      background-color: ${theme.colors.white};
      color: ${theme.colors.black};
      padding: ${theme.spacings[700]} ${theme.spacings[500]};
    `}
`;

export const DrawerCloseStyled = styled(SideSheetClose).attrs({ appearance: ButtonAppearance.SECONDARY })`
  ${({ theme }) =>
    css`
      color: ${theme.colors.blue[800]};
      border: none;
      margin-top: ${theme.spacings[500]};
    `}
`;

interface ProjectProps {
  selected?: boolean;
}

export const ProjectTileStyled = styled(Box).attrs({
  mb: { sm: '400' },
})<ProjectProps>`
  ${({ theme, selected }) =>
    css`
      background-color: ${theme.colors.white};
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
      overflow: hidden;
      ${selected &&
      css`
        border: solid 1px ${theme.colors.blue[700]};
      `}
    `}
`;

export const ProjectImageStyled = styled(Box).attrs({
  p: { sm: '500' },
})<ProjectProps>`
  ${({ theme, selected }) =>
    css`
      width: 168px;
      height: 168px;
      box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14);
      ${selected
        ? css`
            background-image: linear-gradient(225deg, ${theme.colors.blue['600']} 100%, ${theme.colors.blue['500']});
          `
        : css`
            position: relative;
            ::after {
              content: '';
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              background-image: linear-gradient(225deg, ${theme.colors.blue['700']}, ${theme.colors.blue['500']} 0%);
              opacity: 0.1;
            }
          `}
    `}
`;

export const ButtonStyled = styled(Button).attrs({
  appearance: ButtonAppearance.SECONDARY,
})`
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
  border: none;
  margin-top: auto;
  ${({ theme }) =>
    css`
      background-color: ${theme.colors.white};
      font-weight: ${theme.fontWeights['600']};
      color: ${theme.colors.bechtel.blue['800']};
    `}
`;
